import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export const MissingPaymentMethodModalComponent = ({
  isOpen,
  handleClose,
}) => (
  <div>
    <Dialog
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="missing-payment-methoddialog-title"
      aria-describedby="missing-payment-methoddialog-description"
    >
      <DialogTitle id="missing-payment-methoddialog-title">Action Needed Before Subscribing To Paid Plan</DialogTitle>
      <DialogContent>
        <DialogContentText id="missing-payment-methoddialog-description">
          Your organization currently does not have a valid payment method on file.
          Please provide a new payment method in the{' '}
          <a href="/settings/billing?view=payment">payment methods</a>
          {' '}tab before subscribing.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} autoFocus>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  </div>
);

MissingPaymentMethodModalComponent.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
};

MissingPaymentMethodModalComponent.defaultProps = {
  isOpen: false,
  handleClose: () => {},
};

export default MissingPaymentMethodModalComponent;
